import { createTheme } from "@mui/material";

const theme = createTheme({
  colors: {
    primary: "#005f73",
    secondary: "#212f3d",
    terciary: "#b0b0b0",
    white: "#f4f6f7",
  },
  textColors: {
    primary: "#005f73",
    secondary: "#212f3d",
    terciary: "#b0b0b0",
    black: "#000000",
    white: "#ffffff",
  },
  tableColors: {
    header: " #abb2b9 ",
    body: " #d5d8dc ",
  },
  hoverColors: {
    body: "#abb2b9",
  },
  fontSizes: {
    xsmall: "12px",
    small: "14px",
    medium: "18px",
    large: "22px",
  },
  
  typography: {
    fontFamily: "Roboto, sans-serif",
    h1: {
      fontSize: "2rem",
      fontWeight: "bold",
      "@media (max-width: 960px)": {
        fontSize: "1.5rem",
      },
    },
    h2: {
      fontSize: "1.5rem",
      fontWeight: "bold",
      "@media (max-width: 960px)": {
        fontSize: "1.2rem",
      },
    },
    h3: {
      fontSize: "1.2rem",
      fontWeight: "bold",
      "@media (max-width: 960px)": {
        fontSize: "1rem",
      }
    },
    body1: {
      fontSize: "1rem",
      fontWeight: "normal",
      "@media (max-width: 960px)": {
        fontSize: "0.8rem",
      }
    },
    button: {
      textTransform: "none", // Evita mayúsculas en botones
      textDecoration: "none", // Evita subrayado
    },
  },
  breakpoints: {
    values: {
      sm: 0,
      md: 960,
    },
  },
});



export default theme;
